"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVICE_PREMIUM_CONSULTING = exports.SERVICE_TECHNICAL_CONSULTING_ONGOING = exports.SERVICE_INBOUND_CONSULTING_ONGOING = exports.SERVICE_INBOUND_CONSULTING_MONTHLY = exports.SERVICE_TRAINING_MARKETING_FUNDAMENTALS = exports.ADDON_API = exports.ADDON_CUSTOM_SSL = exports.ADDON_TRANSACTIONAL_EMAIL = exports.ADDON_DEDICATED_IP = exports.ADDON_ADS = exports.ADDON_REPORTING = exports.CONTENT_PROFESSIONAL_ONBOARDING = exports.ADDON_LISTS = exports.ADDON_WORKFLOWS = exports.ADDON_BRAND_DOMAIN = exports.CMS_ENTERPRISE_ONBOARDING = exports.CMS_ENTERPRISE = exports.CMS_PROFESSIONAL_ONBOARDING = exports.CMS_PROFESSIONAL = exports.ENTERPRISE_SUITE_ONBOARDING = exports.PROFESSIONAL_SUITE_ONBOARDING = exports.HSFS_SETUP = exports.ADDITIONAL_USERS = exports.ADDITIONAL_CONTACTS_MC = exports.ADDITIONAL_CONTACTS = exports.SERVICE_ENTERPRISE_ONBOARDING = exports.SERVICE_ENTERPRISE = exports.SERVICE_PROFESSIONAL_ONBOARDING = exports.SERVICE_PROFESSIONAL = exports.SERVICE_STARTER_ONBOARDING = exports.SERVICE_STARTER = exports.SALES_ENTERPRISE_ONBOARDING = exports.SALES_ENTERPRISE = exports.SALES_PROFESSIONAL_ONBOARDING = exports.SALES_PROFESSIONAL = exports.SALES_STARTER_ONBOARDING = exports.SALES_STARTER = exports.MARKETING_ENTERPRISE_ONBOARDING = exports.MARKETING_ENTERPRISE_MC = exports.MARKETING_ENTERPRISE = exports.MARKETING_PROFESSIONAL_ONBOARDING = exports.MARKETING_PROFESSIONAL_MC = exports.MARKETING_PROFESSIONAL = exports.MARKETING_STARTER_ONBOARDING = exports.MARKETING_STARTER_MC = exports.MARKETING_STARTER = void 0;
var MARKETING_STARTER = 'marketingStarter';
exports.MARKETING_STARTER = MARKETING_STARTER;
var MARKETING_STARTER_MC = 'marketingStarterMC';
exports.MARKETING_STARTER_MC = MARKETING_STARTER_MC;
var MARKETING_STARTER_ONBOARDING = 'marketingStarterOnboarding';
exports.MARKETING_STARTER_ONBOARDING = MARKETING_STARTER_ONBOARDING;
var MARKETING_PROFESSIONAL = 'marketingProfessional';
exports.MARKETING_PROFESSIONAL = MARKETING_PROFESSIONAL;
var MARKETING_PROFESSIONAL_MC = 'marketingProfessionalMC';
exports.MARKETING_PROFESSIONAL_MC = MARKETING_PROFESSIONAL_MC;
var MARKETING_PROFESSIONAL_ONBOARDING = 'marketingProfessionalOnboarding';
exports.MARKETING_PROFESSIONAL_ONBOARDING = MARKETING_PROFESSIONAL_ONBOARDING;
var MARKETING_ENTERPRISE = 'marketingEnterprise';
exports.MARKETING_ENTERPRISE = MARKETING_ENTERPRISE;
var MARKETING_ENTERPRISE_MC = 'marketingEnterpriseMC';
exports.MARKETING_ENTERPRISE_MC = MARKETING_ENTERPRISE_MC;
var MARKETING_ENTERPRISE_ONBOARDING = 'marketingEnterpriseOnboarding';
exports.MARKETING_ENTERPRISE_ONBOARDING = MARKETING_ENTERPRISE_ONBOARDING;
var SALES_STARTER = 'salesStarter';
exports.SALES_STARTER = SALES_STARTER;
var SALES_STARTER_ONBOARDING = 'salesStarterOnboarding';
exports.SALES_STARTER_ONBOARDING = SALES_STARTER_ONBOARDING;
var SALES_PROFESSIONAL = 'salesProfessional';
exports.SALES_PROFESSIONAL = SALES_PROFESSIONAL;
var SALES_PROFESSIONAL_ONBOARDING = 'salesProfessionalOnboarding';
exports.SALES_PROFESSIONAL_ONBOARDING = SALES_PROFESSIONAL_ONBOARDING;
var SALES_ENTERPRISE = 'salesEnterprise';
exports.SALES_ENTERPRISE = SALES_ENTERPRISE;
var SALES_ENTERPRISE_ONBOARDING = 'salesEnterpriseOnboarding';
exports.SALES_ENTERPRISE_ONBOARDING = SALES_ENTERPRISE_ONBOARDING;
var SERVICE_STARTER = 'serviceStarter';
exports.SERVICE_STARTER = SERVICE_STARTER;
var SERVICE_STARTER_ONBOARDING = 'serviceStarterOnboarding';
exports.SERVICE_STARTER_ONBOARDING = SERVICE_STARTER_ONBOARDING;
var SERVICE_PROFESSIONAL = 'serviceProfessional';
exports.SERVICE_PROFESSIONAL = SERVICE_PROFESSIONAL;
var SERVICE_PROFESSIONAL_ONBOARDING = 'serviceProfessionalOnboarding';
exports.SERVICE_PROFESSIONAL_ONBOARDING = SERVICE_PROFESSIONAL_ONBOARDING;
var SERVICE_ENTERPRISE = 'serviceEnterprise';
exports.SERVICE_ENTERPRISE = SERVICE_ENTERPRISE;
var SERVICE_ENTERPRISE_ONBOARDING = 'serviceEnterpriseOnboarding';
exports.SERVICE_ENTERPRISE_ONBOARDING = SERVICE_ENTERPRISE_ONBOARDING;
var ADDITIONAL_CONTACTS = 'additionalContacts';
exports.ADDITIONAL_CONTACTS = ADDITIONAL_CONTACTS;
var ADDITIONAL_CONTACTS_MC = 'additionalContactsMC';
exports.ADDITIONAL_CONTACTS_MC = ADDITIONAL_CONTACTS_MC;
var ADDITIONAL_USERS = 'additionalUsers';
exports.ADDITIONAL_USERS = ADDITIONAL_USERS;
var HSFS_SETUP = 'hsfsSetup';
exports.HSFS_SETUP = HSFS_SETUP;
var PROFESSIONAL_SUITE_ONBOARDING = 'professionalSuiteOnboarding';
exports.PROFESSIONAL_SUITE_ONBOARDING = PROFESSIONAL_SUITE_ONBOARDING;
var ENTERPRISE_SUITE_ONBOARDING = 'enterpriseSuiteOnboarding';
exports.ENTERPRISE_SUITE_ONBOARDING = ENTERPRISE_SUITE_ONBOARDING;
var CMS_PROFESSIONAL = 'cmsProfessional';
exports.CMS_PROFESSIONAL = CMS_PROFESSIONAL;
var CMS_PROFESSIONAL_ONBOARDING = 'cmsProfessionalOnboarding';
exports.CMS_PROFESSIONAL_ONBOARDING = CMS_PROFESSIONAL_ONBOARDING;
var CMS_ENTERPRISE = 'cmsEnterprise';
exports.CMS_ENTERPRISE = CMS_ENTERPRISE;
var CMS_ENTERPRISE_ONBOARDING = 'cmsEnterpriseOnboarding';
exports.CMS_ENTERPRISE_ONBOARDING = CMS_ENTERPRISE_ONBOARDING;
var ADDON_BRAND_DOMAIN = 'addonBrandDomain';
exports.ADDON_BRAND_DOMAIN = ADDON_BRAND_DOMAIN;
var ADDON_WORKFLOWS = 'addonWorkflows';
exports.ADDON_WORKFLOWS = ADDON_WORKFLOWS;
var ADDON_LISTS = 'addonLists';
exports.ADDON_LISTS = ADDON_LISTS;
var CONTENT_PROFESSIONAL_ONBOARDING = 'contentProfessionalOnboarding';
exports.CONTENT_PROFESSIONAL_ONBOARDING = CONTENT_PROFESSIONAL_ONBOARDING;
var ADDON_REPORTING = 'addonReporting';
exports.ADDON_REPORTING = ADDON_REPORTING;
var ADDON_ADS = 'addonAds';
exports.ADDON_ADS = ADDON_ADS;
var ADDON_DEDICATED_IP = 'addonDedicatedIp';
exports.ADDON_DEDICATED_IP = ADDON_DEDICATED_IP;
var ADDON_TRANSACTIONAL_EMAIL = 'addonTransactionalEmail';
exports.ADDON_TRANSACTIONAL_EMAIL = ADDON_TRANSACTIONAL_EMAIL;
var ADDON_CUSTOM_SSL = 'addonCustomSsl';
exports.ADDON_CUSTOM_SSL = ADDON_CUSTOM_SSL;
var ADDON_API = 'addonApi';
exports.ADDON_API = ADDON_API;
var SERVICE_TRAINING_MARKETING_FUNDAMENTALS = 'serviceTrainingMarketingFundamentals';
exports.SERVICE_TRAINING_MARKETING_FUNDAMENTALS = SERVICE_TRAINING_MARKETING_FUNDAMENTALS;
var SERVICE_INBOUND_CONSULTING_MONTHLY = 'serviceInboundConsultingMonthly';
exports.SERVICE_INBOUND_CONSULTING_MONTHLY = SERVICE_INBOUND_CONSULTING_MONTHLY;
var SERVICE_INBOUND_CONSULTING_ONGOING = 'serviceInboundConsultingOngoing';
exports.SERVICE_INBOUND_CONSULTING_ONGOING = SERVICE_INBOUND_CONSULTING_ONGOING;
var SERVICE_TECHNICAL_CONSULTING_ONGOING = 'serviceTechnicalConsultingOngoing';
exports.SERVICE_TECHNICAL_CONSULTING_ONGOING = SERVICE_TECHNICAL_CONSULTING_ONGOING;
var SERVICE_PREMIUM_CONSULTING = 'servicePremiumConsulting';
exports.SERVICE_PREMIUM_CONSULTING = SERVICE_PREMIUM_CONSULTING;